document.addEventListener("DOMContentLoaded", () => {
    const mobileBreakpoint = 960;
    const body = document.querySelector('body');
    const nav = document.querySelector('.main-navigation-dropdown');
    

    if( nav ) {
        const menuToggle = document.querySelector('.menu-toggle');
        const ddItems = nav.querySelectorAll('li.menu-item-has-children');
        let isMobileView = false;

        menuToggle.addEventListener('click', toggleNav);

        document.addEventListener('keydown', function(event) {
            if (event.key === 'Escape' && nav.classList.contains('active')) {
                toggleNav();
            }
        });

        const query = window.matchMedia(`(max-width: ${mobileBreakpoint}px)`);
        query.addEventListener("change", (e) => navHandleMQ(e.matches));
        navHandleMQ(query.matches);

        function toggleNav() {
            menuToggle.classList.toggle('active');
            nav.classList.toggle('active');
            body.classList.toggle('nav-active');
            body.classList.toggle('scroll-lock');

            if (!nav.classList.contains('active')) {
                resetAllClasses();
            }
        }

        function resetAllClasses() {
            nav.querySelectorAll('.show, .hide, .active').forEach((el) => {
                el.classList.remove('hide', 'show', 'active');
            });
        }

        function navHandleMQ(isMobile) {
            nav.classList.toggle('is-mobile', isMobile);
            nav.classList.toggle('is-desktop', !isMobile);
            isMobileView = isMobile;

            if (isMobile) {
                setupMobileAccordions();
            } else {
                removeMobileAccordions();
            }
            resetAllClasses();
        }

        function setupMobileAccordions() {
            ddItems.forEach((item) => {
                const navLink = item.querySelector(':scope > a');
                const subMenu = item.querySelector(':scope > .sub-menu');

                if (subMenu) {
                    navLink.addEventListener('click', handleMobileClick);
                }
            });
        }

        function removeMobileAccordions() {
            ddItems.forEach((item) => {
                const navLink = item.querySelector(':scope > a');
                navLink.removeEventListener('click', handleMobileClick);
            });
        }

        function handleMobileClick(e) {
            if (!isMobileView) return;

            e.preventDefault();
            const navLink = e.currentTarget;
            const parentItem = navLink.parentElement;
            const subMenu = parentItem.querySelector(':scope > .sub-menu');

            navLink.classList.toggle('active');
            subMenu.classList.toggle('show');
        }
    }
});
